<template>
    <div class="page">
        <v-container>
            <div v-if="course" class="mx-auto overflow-hidden pa-lg-2" style="max-width: 1050px">
                <v-card :flat="phoneOnly" :class="{'soft-shadow': pcOnly}">
                    <v-card-text class="pa-3 pa-lg-6">
                        <div class="d-flex flex-column flex-lg-row">
                            <div class="mr-lg-10">
                                <div>
                                    <v-img :width="pcOnly ? 300 : undefined" height="180" :src="course.image_url" style="border-radius: 7px" />
                                </div>
                                <!-- <div class="mt-3">
                                    <v-btn large depressed color="primary" block outlined style="font-size: 1rem">
                                        <span>{{moneyFormat(course.hourly_price)}} / hour</span>
                                    </v-btn>
                                </div> -->
                            </div>
                            <div class="py-3">
                                <h1 v-if="pcOnly" class="course-title strong-text--text mb-1">
                                    <span>{{course.name}}</span>
                                </h1>
                                <h2 v-else class="course-title strong-text--text mb-1">
                                    <span>{{course.name}}</span>
                                </h2>
                                <div class="d-flex mb-4">
                                    <v-chip small label>{{course.category_name}}</v-chip>
                                    <v-chip v-if="status" dark small label :color="handleStatus(status).color" class="ms-2">{{handleStatus(status).text}}</v-chip>
                                </div>
                                <p class="description">{{course.description}}</p>
                                <div class="mt-6">
                                    <v-btn outlined depressed color="muted" class="me-3" exact :to="{name: 'courses'}">
                                        <v-icon left>mdi-arrow-left</v-icon>
                                        <span>Catalog</span>
                                    </v-btn>
                                    <v-btn v-if="course.details_url && appData.enable_app_w" target="_system" :href="course.details_url" outlined color="primary" depressed class="px-5">
                                        <v-icon left class="me-3">mdi-book-open-outline</v-icon>
                                        <span>Details</span>
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </v-card-text>
                </v-card>

                <template v-if="approved">
                    <v-card :flat="phoneOnly" class="mt-4 px-2" :class="{'soft-shadow': pcOnly, 'transparent': phoneOnly}">
                        <v-card-title>Request Leave</v-card-title>
                        <v-card-subtitle>
                            Request a leave from your classes. You can request up to 1 month per year per enrollment. If you need more, please contact support.
                        </v-card-subtitle>
                        <v-card-text v-if="course.holiday_days_remaining !== undefined" class="pt-2 pb-0">
                            <v-alert dense text type="info" color="blue-grey lighten-4" class="mb-0">
                                <div class="d-flex align-center">
                                    <v-icon class="me-2" color="blue-grey darken-2">mdi-calendar-clock</v-icon>
                                    <span class="medium-text">
                                        <strong>Remaining Holiday Days:</strong> 
                                        <span class="font-weight-bold" :class="course.holiday_days_remaining > 0 ? 'success--text' : 'error--text'">
                                            {{ course.holiday_days_remaining }} day(s)
                                        </span>
                                        <span v-if="course.holiday_days_used > 0" class="muted--text ms-2">
                                            ({{ course.holiday_days_used }} day(s) used)
                                        </span>
                                    </span>
                                </div>
                            </v-alert>
                        </v-card-text>
                        
                        <div v-if="holidays && holidays.length > 0" class="px-4 pb-3">
                            <v-subheader class="px-0">Your Holiday Requests</v-subheader>
                            <v-list dense>
                                <v-list-item v-for="holiday in holidays" :key="holiday.id" class="px-0">
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            {{ holiday.start_date }} to {{ holiday.end_date }}
                                            <v-chip x-small :color="getHolidayStatusColor(holiday.status)" dark class="ml-2">
                                                {{ getHolidayStatusText(holiday.status) }}
                                            </v-chip>
                                        </v-list-item-title>
                                        <v-list-item-subtitle v-if="holiday.rejection_reason" class="red--text">
                                            Reason: {{ holiday.rejection_reason }}
                                        </v-list-item-subtitle>
                                        <v-list-item-subtitle v-if="holiday.cancellation_reason && holiday.cancelled_by_admin_id" class="orange--text">
                                            Cancellation Reason: {{ holiday.cancellation_reason }}
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                    <v-list-item-action v-if="holiday.status === 'pending'">
                                        <v-btn icon small @click="cancelHolidayRequest(holiday.id)">
                                            <v-icon small>mdi-close</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </div>
                        
                        <v-card-actions class="pb-3 px-4">
                            <v-btn depressed color="primary" :block="phoneOnly" class="white--text px-lg-3" @click="requestLeaveDialog = true">
                                <v-icon left>mdi-calendar-remove</v-icon>
                                Request Leave
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                    
                    <v-card v-if="appData.enable_app_w" :flat="phoneOnly" class="mt-4 px-2" :class="{'soft-shadow': pcOnly, 'transparent': phoneOnly}">
                        <v-card-title>Cancel Subscription</v-card-title>
                        <v-card-subtitle>
                            If you canceled your subscription, all next classes of this course would be removed from your calender.
                        </v-card-subtitle>
                        <div v-if="course.finish_requested" class="px-4 pb-3">
                            <v-alert text type="info" icon="mdi-book-remove-outline" dense color="error darken-1">
                                <span class="medium-text font-weight-semibold">You requested to cancel this course, we'll approve your request ASAP.</span>
                            </v-alert>
                        </div>
                        <v-card-actions class="pb-3 px-4">
                            <v-btn :loading="finishing" :disabled="finishing || course.finish_requested" depressed color="red" :block="phoneOnly" class="white--text px-lg-3" @click="finishDialog = true">
                                <v-icon left>mdi-book-cancel-outline</v-icon>
                                Cancel Subscription
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </template>

                <template v-else>
                    <!-- Blocked: pending evaluation not completed yet -->
                    <v-card v-if="wizardMeta && wizardMeta.has_pending_evaluation" class="mt-4 px-2" :class="{'soft-shadow': pcOnly, 'transparent': phoneOnly}">
                        <v-card-text class="pa-6 text-center">
                            <v-icon color="orange darken-2" size="56" class="mb-4">mdi-clock-alert-outline</v-icon>
                            <h3 class="mb-3 strong-text--text" style="font-size: 1.25rem;">Complete Your Evaluation First</h3>
                            <p class="mb-5 text--text" style="max-width: 480px; margin: 0 auto; line-height: 1.6;">
                                You have a pending evaluation session that must be completed before you can enroll in any course. Please attend your evaluation, and once it's been reviewed by our team, you'll be able to enroll.
                            </p>
                            <v-btn depressed color="primary" :to="{name: 'home'}">
                                <v-icon left>mdi-calendar</v-icon>
                                Go to Dashboard
                            </v-btn>
                        </v-card-text>
                    </v-card>

                    <!-- New enrollment wizard (step-based form) -->
                    <enrollment-wizard 
                        v-else-if="!course.enrolled"
                        ref="enrollmentWizard"
                        class="mt-4"
                        :course="course"
                        :course-meta="courseMeta"
                        :wizard-meta="wizardMeta"
                        :mobile="phoneOnly"
                        :enrolling="enrolling"
                        @enroll="enrollCourse"
                        @show-message="handleWizardMessage"
                    />

                    <!-- Enrolled user view with edit capability -->
                    <v-card v-else class="mt-4 px-2" :class="{'soft-shadow': pcOnly, 'transparent': phoneOnly}">
                        <v-card-title class="d-flex justify-space-between" :class="{'px-1 mb-2': phoneOnly}">
                            <div>
                                <v-icon color="primary" left>mdi-book-clock</v-icon>
                                <span>Free Trial Request</span>
                            </div>
                            <div>
                                <v-btn :disabled="editable" color="blue-grey" outlined :dark="!editable" depressed @click="allowEdit = true">
                                    <v-icon size="20" left>mdi-pencil</v-icon>
                                    <span>Edit</span>
                                </v-btn>
                            </div>
                        </v-card-title>
                        <v-card-subtitle class="mb-2">You've requested to enroll in this course but your enrollment is still in progress.</v-card-subtitle>
                        <v-card-text :class="{'px-0': phoneOnly}">
                            <div class="alerts">
                                <v-alert v-if="status === 'action-needed'" type="warning" color="error" icon="mdi-progress-alert" text>
                                    <div class="medium-text text--text">
                                        <div class="red--text font-weight-semibold mb-1">Change Needed:</div>
                                        <div class="multiline red--text text--darken-4">
                                            <span>{{course.enrollment.admin_comment}}</span>
                                        </div>
                                    </div>
                                </v-alert>

                                <v-alert v-else type="info" color="blue-grey" icon="mdi-progress-clock" text>
                                    <div class="medium-text text--text">
                                    <b>Thank you for registering!</b> <br>
                                    One of our support team will accept your request within few minutes..
                                    </div>
                                </v-alert>
                            </div>

                            <v-form>
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <v-select :readonly="!editable" v-model="preferredDays" :items="preferredDaysItems" multiple outlined label="Preferred Days" placeholder="Preferred Days For Classes" hide-details></v-select>
                                    </v-col>

                                    <v-col cols="12" md="6">
                                        <v-menu v-model="trialDateMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto" >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field :disabled="!editable" outlined v-model="trialDate" label="Trial Date" placeholder="Trial date" prepend-inner-icon="mdi-calendar" readonly hide-details v-bind="attrs" v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker :min="minTrialDate" v-model="trialDate" @input="trialDateMenu = false" color="primary"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    
                                    <v-col cols="12" md="6">
                                        <time-input v-model="trialTime" :dense="phoneOnly" :readonly="!editable" :hide-icon="phoneOnly" half-format outlined label="Trial Class Time" placeholder="Trial Class Time" />
                                    </v-col>

                                    <v-col cols="12" class="pa-0">
                                        <v-divider class="ma-3"></v-divider>
                                        <v-subheader>
                                            <v-icon size="20" class="me-1">mdi-clock-outline</v-icon>
                                            <span class="strong-text--text me-1">Schedule</span> <span v-if="pcOnly">(Provide us with your preferred future schedule to find an available teacher)</span>
                                        </v-subheader>
                                    </v-col>
                                    <v-col cols="12" lg="12">
                                        <v-menu v-model="startDateMenu" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto" >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field :disabled="!preferredDays.length || !editable" outlined v-model="startDate" label="Start Date" placeholder="Start date" prepend-inner-icon="mdi-calendar" readonly hide-details v-bind="attrs" v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker :allowed-dates="allowedDates" :min="minStartDate" v-model="startDate" @input="startDateMenu = false" color="primary"></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <v-select :readonly="!editable" :items="courseDurationItems" v-model="classDuration" outlined label="Class Duration" placeholder="Choose Class Duration" hide-details></v-select>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <v-select :readonly="!editable" :items="classesPerWeekItems" v-model="classesPerWeek" :disabled="!classDuration" outlined label="Classes / Week" placeholder="How Many Classes Weekly" hide-details></v-select>
                                    </v-col>
                                    <v-row v-for="(entry, i) in timeEntries" :key="'edit-time-entry-' + i" class="ma-0">
                                        <v-col cols="5" :class="{'px-1': phoneOnly}">
                                            <v-select :dense="phoneOnly" :readonly="!editable" :disabled="!preferredDays.length" v-model="timeEntries[i]['day']" :items="selectedPreferredDays" outlined label="Day" placeholder="Choose Class Day" hide-details></v-select>
                                        </v-col>
                                        <v-col cols="6" :class="{'px-1': phoneOnly}">
                                            <time-input v-model="timeEntries[i]['from']" :dense="phoneOnly" :hide-icon="phoneOnly" half-format :disabled="(!timeEntries[i]['day'] && timeEntries[i]['day'] !== 0) || !editable" outlined label="Class Time" placeholder="Class Time" />
                                        </v-col>
                                        <v-col cols="1" class="d-flex justify-start align-center" :class="{'px-0': phoneOnly}">
                                            <v-btn :disabled="!editable" v-if="i > 0" color="error" icon @click="removeTimeEntry(i)">
                                                <v-icon size="20">mdi-close</v-icon>
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                    <v-col cols="12" class="py-0">
                                        <v-btn :disabled="!editable" color="primary" dense small text @click="addTimeEntry">
                                            <v-icon left>mdi-plus</v-icon>
                                            Additional Time Entry
                                        </v-btn>
                                    </v-col>
                                    
                                    <v-col cols="12" class="pa-0">
                                        <v-divider class="mx-3 mt-3 mb-5"></v-divider>
                                    </v-col>
                                    <v-col cols="12" class="py-1">
                                        <v-textarea v-model="comment" :disabled="!editable" rows="4" no-resize outlined label="Comment" placeholder="Leave us a message (optional)" hide-details></v-textarea>
                                    </v-col>
                                </v-row>

                                <div class="actions mt-3">
                                    <v-btn :loading="updating" :disabled="updating || !editable" :dark="!updating && editable" large depressed color="blue-grey" style="min-width: 180px" @click="updateEnrollment">
                                        <v-icon left>mdi-book-edit-outline</v-icon>
                                        <span>Save Changes</span>
                                    </v-btn>
                                </div>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </template>

            </div>
        </v-container>

        <v-dialog v-model="finishDialog" max-width="375">
            <v-card>
                <v-card-title>Cancel Subscription Request</v-card-title>
                <v-card-text>
                    <div class="mb-6">
                        Are you sure that you want to cancel your subscription? You can enroll again later.
                    </div>

                    <div>
                        <v-textarea v-model="finishReason" outlined rows="4" placeholder="Reason of cancelation" no-resize hide-details></v-textarea>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="muted" @click="finishDialog = false">cancel</v-btn>
                    <v-btn text color="error" @click="finishCourse">Confirm</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="requestLeaveDialog" max-width="500">
            <v-card>
                <v-card-title>Request Leave</v-card-title>
                <v-card-text>
                    <v-menu v-model="holidayStartDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="holidayStartDate"
                                label="Start Date"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                hide-details
                                class="mb-3"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="holidayStartDate"
                            :min="minHolidayDate"
                            @input="holidayStartDateMenu = false"
                            color="primary"
                        ></v-date-picker>
                    </v-menu>
                    
                    <v-menu v-model="holidayEndDateMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="holidayEndDate"
                                label="End Date"
                                prepend-inner-icon="mdi-calendar"
                                readonly
                                outlined
                                v-bind="attrs"
                                v-on="on"
                                hide-details
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="holidayEndDate"
                            :min="holidayStartDate || minHolidayDate"
                            @input="holidayEndDateMenu = false"
                            color="primary"
                        ></v-date-picker>
                    </v-menu>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn text color="muted" @click="requestLeaveDialog = false">Cancel</v-btn>
                    <v-btn text color="primary" :loading="requestingLeave" @click="requestLeave">Submit</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Enrollment Success Dialog -->
        <enrollment-success-dialog 
            v-model="successDialog" 
            :course="course" 
            @go-home="goToHome"
        />
    </div>
</template>

<script>
// @ is an alias to /src

import {isEqual} from 'lodash'

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

import TimeInput from '@/components/custom/time-input'
import EnrollmentWizard from './Course/EnrollmentWizard.vue'
import EnrollmentSuccessDialog from './Course/EnrollmentSuccessDialog.vue'

export default {
    name: "Course",
    components: {
        TimeInput,
        EnrollmentWizard,
        EnrollmentSuccessDialog
    },
    data(){
        const d = new Date();
        d.setDate(d.getDate()+1); // min start_date is tomorrow

        const trialMin = new Date();

        return {
            course: null,
            courseMeta: null,
            wizardMeta: null,
            
            // For edit enrolled form only
            timeEntries: [
                {day: '', from: '', to: ''},
                {day: '', from: '', to: ''},
                {day: '', from: '', to: ''},
            ],

            loading: false,
            enrolling: false,
            startDateMenu: false,
            minStartDate: d.toISOString().substr(0, 10),
            minTrialDate: trialMin.toISOString().substr(0, 10),
            trialDateMenu: false,
            
            // For edit enrolled form only
            classDuration: '',
            classesPerWeek: '',
            startDate: '',
            trialDate: '',
            trialTime: '',
            comment: '',
            preferredDays: [],

            updating: false,
            finishing: false,
            allowEdit: false,

            preferredDaysItems: [
                {text: 'Saturday', value: 6},
                {text: 'Sunday', value: 0},
                {text: 'Monday', value: 1},
                {text: 'Tuesday', value: 2},
                {text: 'Wednesday', value: 3},
                {text: 'Thursday', value: 4},
                {text: 'Friday', value: 5},
            ],

            finishDialog: false,
            finishReason: '',
            requestLeaveDialog: false,
            holidayStartDate: '',
            holidayEndDate: '',
            holidayStartDateMenu: false,
            holidayEndDateMenu: false,
            requestingLeave: false,

            // Success dialog
            successDialog: false,
        }
    },
    computed: {
        id(){
            return this.$route.params.id;
        },
        editable(){
            if (this.status === 'action-needed' || !this.course.enrolled){
                return true;
            }
            return this.allowEdit;
        },
        approved(){
            // user enrollment approved
            return this.course.enrolled && this.course.enrollment.status === 'approved';
        },
        status(){
            return this.course.enrolled ? this.course.enrollment.status : null;
        },
        data(){
            return {
                class_duration: this.classDuration,
                weekly_classes: this.classesPerWeek,
                start_day: this.startDate,
                suggested_trial_day: this.trialDate,
                trial_time: this.trialTime,
                date_of_birth: this.dateOfBirth,
                comment: this.comment,
                preferred_days: this.preferredDays,
                schedule: this.timeEntries.filter(item=>!!item.day || item.day === 0)
            }
        },
        courseDurationItems(){
            if (!this.courseMeta){
                return [];
            }
            const items = this.courseMeta.class_duration_items;
            return items.map(item=>{
                const hourlyPrice = this.course.enrollment && this.course.enrollment.hourly_price ? this.course.enrollment.hourly_price : this.course.hourly_price;
                const classPrice = hourlyPrice * (item.value/60); // hourly price * minutes/60
                return {
                    text: this.appData.enable_app_w ? `${item.text} (${this.moneyFormat(classPrice)} / class)` : item.text,
                    value: item.value,
                }
            })
        },
        classesPerWeekItems(){
            let items = [
                {text: '2 classes / week', value: 2},
                {text: '3 classes / week', value: 3},
                {text: '4 classes / week', value: 4},
                {text: '5 classes / week', value: 5},
                {text: '6 classes / week', value: 6},
            ];
            // if one class duration not less than 1 hour, add one class to items
            if (this.classDuration && this.classDuration / 60 >= 1){
                items.unshift({text: '1 class / week', value: 1});
            }
            return items.map(item=>{
                const weeklyPrice = item.value * this.classPrice;
                if (this.appData.enable_app_w){
                    item.text += ` (${this.moneyFormat(weeklyPrice)} / week)`
                }
                
                return item;
            });
        },
        selectedPreferredDays(){
            return this.preferredDaysItems.filter(day=>{
                return this.preferredDays.includes(day.value);
            })
        },
        classPrice(){
            const hourlyPrice = this.course.enrollment && this.course.enrollment.hourly_price ? this.course.enrollment.hourly_price : this.course.hourly_price;
            const classPrice = hourlyPrice * (this.classDuration/60); // hourly price * minutes/60

            return classPrice;
        },
        holidays(){
            return this.course && this.course.holidays ? this.course.holidays : [];
        },
        hasPendingHoliday(){
            return this.holidays.some(h => h.status === 'pending');
        },
        minHolidayDate(){
            const d = new Date();
            d.setDate(d.getDate() + 1); // Add one day to get tomorrow
            return d.toISOString().substr(0, 10);
        },
        ...GlobalComputed
    },
    watch: {
        id(){
            this.loadData();
        },
    },
    methods: {
        loadData(){
            if (!this.loading){
                this.loading = true;
                return this.$store.dispatch('getCourse', {id: this.id}).then(response=>{
                    this.course = response.data.data;
                    this.courseMeta = response.data.meta;
                    this.wizardMeta = response.data.wizard_meta || null;
                    this.loading = false;

                    if (this.course.enrolled){
                        this.fillForm();
                    }

                }).catch(()=>{
                    this.$router.push({name: 'courses'});
                    this.loading = false;
                    this.showMsg('Error occurred during fetching data', 'error');
                })
            }
        },
        enrollCourse(enrollmentData){
            if (!this.enrolling){
                    this.enrolling = true;
                return this.$store.dispatch('enrollCourse', {id: this.id, data: enrollmentData}).then(response=>{
                        this.course = response.data.data;
                        this.enrolling = false;
                        this.$store.dispatch('updateNotifications');
                    this.$store.dispatch('refreshUser');
                    // Show success dialog
                    this.successDialog = true;
                    }).catch(error => {
                        this.enrolling = false;
                        if (error.response && error.response.status === 422){
                            let errors = error.response.data.errors;
                            // Evaluation slot error: jump back to eval step in wizard
                            if (errors && errors.evaluation && this.$refs.enrollmentWizard) {
                                this.$refs.enrollmentWizard.goToEvaluationStep();
                                this.showMsg(errors.evaluation[0], 'error');
                            } else {
                                this.showMsg(errors[Object.keys(errors)[0]][0], 'error');
                            }
                        }else{
                            this.showMsg('Error occurred during enrolling course', 'error');
                        }
                    })
                }
        },
        handleWizardMessage({ text, type }) {
            this.showMsg(text, type);
        },
        updateEnrollment(){
            if (!this.updating){
                if (this.validate()){ /* && this.isFormUpdated() */
                    this.updating = true;
                    return this.$store.dispatch('updateCourseEnrollment', {id: this.id, data: this.data}).then(response=>{
                        this.updating = false;
                        this.course = response.data.data;
                        this.showMsg('Enrollment form updated successfully', 'success');
                        this.allowEdit = false;
                    }).catch(error=>{
                        this.updating = false;
                        if (error.response && error.response.status === 422){
                            // coming errors from backend
                            let errors = error.response.data.errors;
                            this.showMsg(errors[Object.keys(errors)[0]][0]);
                        }else{
                            this.showMsg('Error occurred during submitting', 'error');
                        }
                    })
                }
            }

        },
        finishCourse(){
            if (!this.finishing){
                if (this.finishReason){
                    this.finishDialog = false;
                    this.finishing = true;
                    return this.$store.dispatch('finishEnrollment', {id: this.id, data: {reason: this.finishReason}}).then(response=>{
                        this.finishing = false;
                        // this.course = response.data.data;f
                        this.showMsg('Your request sent successfully', 'success');
                        this.$router.push({name: 'courses'});
                    }).catch(error=>{
                        this.finishing = false;
                        this.showMsg('Error occurred during finishing', 'error');
                    })
                }else{
                    this.showMsg('Please enter the reason.', 'warning');
                }
            }
        },
        isFormUpdated(){
            const enrollment = this.course.enrollment;
            if (enrollment){
                const newData = this.data,
                    data = Object.keys(newData).reduce((obj, key) => {obj[key] = enrollment[key]; return obj}, {});
                
                const updated = !isEqual(newData, data);
                if (!updated) this.showMsg('Please update enrollment form to resubmit');
                return updated;
            }
            return false;
        },
        fillForm(){
            if (this.course.enrollment){
                const enrollment = this.course.enrollment;
                this.classDuration = enrollment.class_duration;
                this.classesPerWeek = enrollment.weekly_classes;
                this.startDate = enrollment.start_day;
                this.trialDate = enrollment.suggested_trial_day;
                // Handle null/undefined trial_time safely
                this.trialTime = enrollment.trial_time ? enrollment.trial_time.split(':00')[0] : '';
                this.comment = enrollment.comment || '';
                this.preferredDays = enrollment.preferred_days || [];
                this.timeEntries = enrollment.schedule || [
                    {day: '', from: '', to: ''},
                    {day: '', from: '', to: ''},
                    {day: '', from: '', to: ''},
                ];
            }
        },
        validate(){
            const data = this.data;
            if (!data.class_duration || !data.weekly_classes || !data.start_day || !data.trial_time || !data.date_of_birth){
                this.showMsg('Required inputs cannot be empty', 'error');
                return false;
            }else if (data.preferred_days.length < data.weekly_classes){
                this.showMsg(`"Preferred Days" must be equal or more than "Classes/ Week"`, 'error');
                this.showHelp = true;
                return false;
            }else if (data.schedule.length < data.weekly_classes){
                this.showMsg(`"Schedule" times must be equal or more than "Classes/ Week"`, 'error');
                this.showHelp = true;
                return false;
            }

            let timeValid = true;
            data.schedule.forEach(scheduleItem=>{
                if (!scheduleItem.from){
                    this.showMsg(`Time input is required`, 'error');
                    this.showHelp = true;
                    timeValid = false;
                }
            })
            if (!timeValid) return false;
            return true;
        },
        allowedDates(day){
            const d = new Date(day);
            return this.preferredDays.includes(d.getUTCDay()); // check if day of d is one of preferredDays, getUTCDay to prevent bugs with some timezones
        },
        addTimeEntry(){
            this.timeEntries.push({day: '', from: '', to: ''});
        },
        removeTimeEntry(i){
            this.timeEntries.splice(i, 1);
        },
        requestLeave(){
            if (!this.holidayStartDate || !this.holidayEndDate){
                this.showMsg('Please select both start and end dates', 'error');
                return;
            }

            const startDate = new Date(`${this.holidayStartDate}T00:00:00`);
            const endDate = new Date(`${this.holidayEndDate}T00:00:00`);
            const requestDays = Math.round((endDate - startDate) / 86400000) + 1;

            if (requestDays < 3){
                this.showMsg('Holiday request must be at least 3 days', 'error');
                return;
            }
            
            if (!this.course.enrollment || !this.course.enrollment.id){
                this.showMsg('Enrollment not found', 'error');
                return;
            }
            
            this.requestingLeave = true;
            this.$store.dispatch('requestLeave', {
                enrollmentId: this.course.enrollment.id,
                data: {
                    start_date: this.holidayStartDate,
                    end_date: this.holidayEndDate,
                }
            }).then(response => {
                this.requestingLeave = false;
                this.requestLeaveDialog = false;
                this.holidayStartDate = '';
                this.holidayEndDate = '';
                this.showMsg('Holiday request submitted successfully', 'success');
                this.loadData(); // Reload course data to get updated holidays
            }).catch(error => {
                this.requestingLeave = false;
                if (error.response && error.response.status === 422){
                    let errors = error.response.data.errors;
                    const errorMessage = errors[Object.keys(errors)[0]][0] || error.response.data.message || 'Error occurred during submitting holiday request';
                    this.showMsg(errorMessage, 'error');
                }else{
                    this.showMsg('Error occurred during submitting holiday request', 'error');
                }
            });
        },
        cancelHolidayRequest(holidayId){
            if (!confirm('Are you sure you want to cancel this holiday request?')){
                return;
            }
            
            this.$store.dispatch('cancelHoliday', {holidayId: holidayId}).then(response => {
                this.showMsg('Holiday request cancelled successfully', 'success');
                this.loadData(); // Reload course data to get updated holidays
            }).catch(error => {
                if (error.response && error.response.status === 422){
                    let errors = error.response.data.errors;
                    const errorMessage = errors[Object.keys(errors)[0]][0] || error.response.data.message || 'Error occurred during cancelling holiday request';
                    this.showMsg(errorMessage, 'error');
                }else{
                    this.showMsg('Error occurred during cancelling holiday request', 'error');
                }
            });
        },
        getHolidayStatusColor(status){
            const colors = {
                'pending': 'orange',
                'approved': 'green',
                'rejected': 'red',
                'cancelled': 'grey',
            };
            return colors[status] || 'grey';
        },
        getHolidayStatusText(status){
            const texts = {
                'pending': 'Pending',
                'approved': 'Approved',
                'rejected': 'Rejected',
                'cancelled': 'Cancelled',
            };
            return texts[status] || status;
        },
        goToHome(){
            this.successDialog = false;
            this.$router.push({name: 'home'});
        },
        ...GlobalMethods
    },
    mounted(){
        this.loadData();
    }
};
</script>
<style lang="scss" scoped>
    .course-title{
        line-height: 2.1rem;
    }
    .description{
        font-size: 1rem;
        line-height: 1.5rem;
    }
    .multiline{
        white-space: pre-line;
    }
</style>
